import { useSuspenseQuery } from '@tanstack/react-query';
import { useTenantedClient } from '../stores/org';
import { useTenantedQueryKey } from './use-tenanted-query-key';
import { Assert } from '@cotera/utilities';

export const useUsage = () => {
  const key = useTenantedQueryKey(['usage']);
  const client = useTenantedClient();
  const { data } = useSuspenseQuery({
    queryKey: key,
    queryFn: async () => {
      return Assert.assertOk(
        await client.atc.allocator.remainingRateLimitsByRule({})
      );
    },
    //every 10 seconds
    refetchInterval: 10000,
  });
  return data;
};
